// TODO - Documentar
import * as con from "../../GlobalConstants"
import LoadingIcon from '../../templates/loading/LoadingIcon'

// Style
import "../ComponentsGlobalStyle.css"
import { RefTransactionsHook } from "../hooks/TransactionsHooks"

function TransactionTableVisualizer({children, transactionType}) {
  
  // Transactions Loaded
  const transStatus = RefTransactionsHook(con.TRANSACTIONS_LOADED)


  // Loading
  const loading = RefTransactionsHook(con.LOADING_CURRENT_TRANSACTIONS)

 

  return (
    <div>        
        {
            transStatus[transactionType][con.STATUS] === con.LOADING ?
                <div>
                    <h5>Extrayendo de la base de datos.</h5>
                    <LoadingIcon/> 
                </div> :    
                  loading ? <h4>Cargando...</h4>
                          : children                                 
        }
    </div>
  )
}

export default TransactionTableVisualizer